import { AxiosPostBody } from '../../../types/AxiosPost';
import { UserCredentialsType } from '../../../types/types';
import axiosPost from '../axiosPost';

export const AFIPDatosGet = async (arg: UserCredentialsType, cuit:string) => {
    const body: AxiosPostBody = {
        "service": "AFIPDatosGet",
        "params": {
            "cuit": cuit
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
       
        return result
    } catch (err) {
        console.log(err)
    }
};